import { createAPI } from './util'

let instance = createAPI()

/** 获取礼包页评论数据 */
function pkg_comment_get(opts) {
  return instance({
    method: 'get',
    url: '/json/goods/pkgComment.json',
    opts: opts,
  })
}

/** 获取新手指引问题 */
function guideline_doubt_get(opts) {
  return instance({
    method: 'get',
    url: '/json/guideline/doubt.json',
    opts: opts,
  })
}

/** 获取新手指引答案 */
function guideline_guide_get(opts) {
  return instance({
    method: 'get',
    url: '/json/guideline/guide.json',
    opts: opts,
  })
}

/** 读书节资源目录 */
function reading_festival_resource_get(opts) {
  return instance({
    method: 'get',
    url: '/json/readingFestivalResource.json',
    opts: opts,
  })
}

export { reading_festival_resource_get,pkg_comment_get, guideline_doubt_get, guideline_guide_get }
